import styled from "styled-components";

import * as Grid from "@ui/Atoms";

export const Root = styled(Grid.Container).attrs({ as: "section" })`
  padding-top: ${({ theme }) => theme.spacing.spacing_32};
  padding-bottom: ${({ theme }) => theme.spacing.spacing_32};

  ${props => props.theme.breakpoints.tablet} {
    padding-top: ${({ theme }) => theme.spacing.spacing_64};
    padding-bottom: ${({ theme }) => theme.spacing.spacing_64};
  }
  ${props => props.theme.breakpoints.desktop} {
    padding-top: ${({ theme }) => theme.spacing.spacing_80};
    padding-bottom: ${({ theme }) => theme.spacing.spacing_80};
  }
`;

export const Container = styled(Grid.Column)`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.spacing_32};
`;

export const TimelineList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.spacing_24};
`;

export const TimelineItem = styled.li`
  display: grid;
  grid-template-columns: 27px 1fr;
  gap: ${({ theme }) => theme.spacing.spacing_8};
`;

export const TimelineIcon = styled.div`
  padding: ${({ theme }) => theme.spacing.spacing_8} 0;
  color: ${({ theme }) => theme.palette.blue500};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.spacing_16};

  &::before {
    content: "";
    flex: 0 0 auto;
    width: 17px;
    height: 17px;
    border-radius: 50%;
    background-color: currentColor;
  }

  &::after {
    content: "";
    flex: 1;
    width: 2px;
    background-color: currentColor;
  }
`;

export const Event = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.spacing_12};

  ${props => props.theme.breakpoints.tablet} {
    padding-bottom: ${({ theme }) => theme.spacing.spacing_16};
  }
`;
